import { render, staticRenderFns } from "./ontick-editable-select.component.vue?vue&type=template&id=6134e8d0&scoped=true"
import script from "./ontick-editable-select.component.vue?vue&type=script&lang=js"
export * from "./ontick-editable-select.component.vue?vue&type=script&lang=js"
import style0 from "./ontick-editable-select.component.vue?vue&type=style&index=0&id=6134e8d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6134e8d0",
  null
  
)

export default component.exports